import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  Renderer2
} from '@angular/core';
import {
  BreakpointClassesCtor,
  CanGenerateBreakpointClasses,
  InputValue,
  mixinBreakpointClassesGenerator
} from 'ng-labs/core';

class FlexGridColumnBase {
  constructor(public renderer: Renderer2) {}
}

const FlexGridColumnMixinBase: BreakpointClassesCtor &
  typeof FlexGridColumnBase = mixinBreakpointClassesGenerator(
  FlexGridColumnBase
);

/**
 * `<labs-flex-grid-column>` displays a grid column.
 */
@Component({
  selector: 'labs-flex-grid-column',
  template: '<ng-content></ng-content>',
  styleUrls: ['./flex-grid-column.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FlexGridColumnComponent extends FlexGridColumnMixinBase
  implements CanGenerateBreakpointClasses {
  @Input()
  set span(value: InputValue) {
    const element = this.elementRef.nativeElement;
    const prefix = 'span';

    if (value !== this._span) {
      this.removeBreakpointClasses(element, prefix, this._span);
      this.addBreakpointClasses(element, prefix, value);

      this._span = value;
    }
  }

  private _span: InputValue;

  constructor(private elementRef: ElementRef, public renderer: Renderer2) {
    super(renderer);
  }
}
